import React, {
  useMemo,
  useState,
  useCallback,
  useRef
} from 'react';
import { Button } from 'devextreme-react';
import Drawer from 'devextreme-react/drawer';
import Form, {
  SimpleItem,
  RequiredRule,
  GroupItem,
  ButtonItem
} from 'devextreme-react/form';
import DataGrid, {
  FilterRow,
  Scrolling,
  Column,
  Selection,
  MasterDetail
} from 'devextreme-react/data-grid';
import style from './activitymetric.module.scss';
import Details from './Details';

const cursor = {};

const ActivityMetric = ({
  metricReducer: { listShort },
  metricUserActivityShort
}) => {
  const form = useRef(null);
  const [visibleDrawer, setVisibleDrawer] = useState(true);
  const [dateOnForm, setDateOnFrom] = useState({});

  const formOnSubmit = useCallback((e) => {
    e.preventDefault();
    metricUserActivityShort({
      dateFrom: cursor.dateFrom,
      dateTo: cursor.dateTo
    });
    setDateOnFrom({
      dateFrom: cursor.dateFrom,
      dateTo: cursor.dateTo
    });
  }, [metricUserActivityShort]);

  const RenderLeftDrawer = useMemo(() => () => (
    <div className={style.form}>
      <form method="POST"
            onSubmit={formOnSubmit}
      >
        <Form labelLocation="top"
              width="100%"
              readOnly={false}
              showColonAfterLabel
              showValidationSummary={false}
              formData={cursor}
              ref={form}
        >
          <GroupItem>
            <SimpleItem dataField="dateFrom"
                        editorType="dxDateBox"
                        label={{ text: 'Дата с' }}
                        editorOptions={{
                          stylingMode: 'filled',
                          dateSerializationFormat: 'yyyy-MM-dd'
                        }}
            >
              <RequiredRule message="Выберите значение" />
            </SimpleItem>
            <SimpleItem dataField="dateTo"
                        editorType="dxDateBox"
                        label={{ text: 'Дата по' }}
                        editorOptions={{
                          stylingMode: 'filled',
                          dateSerializationFormat: 'yyyy-MM-dd'
                        }}
            >
              <RequiredRule message="Выберите значение" />
            </SimpleItem>
            <ButtonItem horizontalAlignment="right"
                        buttonOptions={{
                          text: 'Построить',
                          type: 'default',
                          useSubmitBehavior: true
                        }}
            />
          </GroupItem>
        </Form>
      </form>
    </div>
  ), [formOnSubmit]);

  const renderDetail = useCallback((props) => {
    const { hasDetails } = props.data;
    if (hasDetails) {
      return (
        <Details data={props.data} />
      );
    }
    return (
      <div>Детальной информации нет</div>
    );
  }, []);
  const selectionChanged = useCallback((e) => {
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
  }, []);

  const renderMain = useMemo(() => (
    <div className={style.main}>
      <Button elementAttr={{ class: style.buttonDrawer }}
              stylingMode={'text'}
              icon={!visibleDrawer ? 'filter' : 'arrowleft'}
              type="normal"
              onClick={() => setVisibleDrawer((current) => !current)}
      />
      <div className={style.data}>
        <DataGrid hoverStateEnabled
                  allowColumnReordering
                  allowColumnResizing
                  columnAutoWidth
                  showBorders
                  onSelectionChanged={selectionChanged}
                  dataSource={
                    listShort
                    && listShort.length
                    && listShort.map((item) => ({
                      ...item,
                      ...dateOnForm
                    }))
                  }
                  height="100%"
                  width="100%"
        >
          <Column dataField="code"
                  caption="Код метрики"
                  width={100}
          />
          <Column dataField="description"
                  caption="Описание метрики"
          />
          <Column dataField="hasDetails"
                  caption="Детализация"
          />
          <Column dataField="amount"
                  caption="Кол-во"
          />
          <Column dataField="plant"
                  caption="Наименование склада"
          />
          <Column dataField="plantsAmount"
                  caption="Кол-во складов"
          />
          <Selection mode="single" />
          <Scrolling mode="virtual" />
          <FilterRow visible />
          <MasterDetail enabled={false} render={renderDetail} />
        </DataGrid>
      </div>
    </div>
  ), [
    dateOnForm,
    listShort,
    renderDetail,
    selectionChanged,
    visibleDrawer
  ]);

  return (
    <div className={style.container}>
      <Drawer opened={visibleDrawer}
              elementAttr={{ class: style.drawer }}
              component={RenderLeftDrawer}
              position="left"
              revealMode="slide"
              openedStateMode="shrink"
      >
        { renderMain }
      </Drawer>
    </div>
  );
};

export default ActivityMetric;
